import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { 
    MdDashboard, 
    MdBusinessCenter, 
    MdPeople, 
    MdAdd,
    MdViewList,
    MdSettings,
    MdLogout,
    MdPerson,
    MdMenu,
    MdChevronLeft,
    MdTrackChanges,
    MdClose,
    MdKeyboardArrowRight,
} from 'react-icons/md';
import Cookies from 'js-cookie';
import { IoMdArrowDropdown } from 'react-icons/io';
import './Sidebar.css';

const Sidebar = () => {
    const [isOpen, setIsOpen] = useState(true);
    const [isMobile, setIsMobile] = useState(false);
    const [openDropdown, setOpenDropdown] = useState('');
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth <= 768);
            if (window.innerWidth <= 768) {
                setIsOpen(false);
            } else {
                setIsOpen(true);
            }
        };

        checkMobile();
        window.addEventListener('resize', checkMobile);
        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    const handleDropdown = (menu) => {
        setOpenDropdown(openDropdown === menu ? '' : menu);
    };

    const handleLogout = () => {
        Cookies.remove('token');
        navigate('/login');
    };

    const isActive = (path) => {
        return location.pathname === path;
    };

    const toggleSidebar = () => {
        setIsOpen(!isOpen);
    };

    const MenuItem = ({ icon: Icon, text, path, onClick, hasDropdown = false }) => (
        <div 
            className={`menu-item ${isActive(path) ? 'active' : ''}`}
            onClick={onClick}
        >
            <div className="menu-item-content">
                <Icon className="menu-icon" />
                <span className="menu-text">{text}</span>
                {hasDropdown && (
                    <IoMdArrowDropdown 
                        className={`dropdown-arrow ${openDropdown === text ? 'open' : ''}`}
                    />
                )}
            </div>
        </div>
    );

    const DropdownItem = ({ icon: Icon, text, path }) => (
        <Link to={path} className={`dropdown-item ${isActive(path) ? 'active' : ''}`}>
            <Icon className="dropdown-icon" />
            <span style={{marginLeft: '10px'}} className="dropdown-text">{text}</span>
        </Link>
    );

    // Mobile menu trigger
    const MobileMenuTrigger = () => (
        <button 
            className="mobile-menu-trigger"
            onClick={toggleSidebar}
            aria-label="Toggle menu"
        >
            <MdMenu />
        </button>
    );



    return (
        <>
            {isMobile && <MobileMenuTrigger />}
            
            <div className={`sidebar ${isOpen ? 'open' : 'closed'} ${isMobile ? 'mobile' : ''}`}>
                <div className="sidebar-header">
                    <div className="logo-container">
                        <img src="/celebration logo.png" alt="PMS" className="logo-img" />
                    </div>
                </div>

                <div className="sidebar-content">
                    <div className="menu-section">
                        <Link to="/coo/dashboard">
                            <MenuItem 
                                icon={MdDashboard}
                                text="Dashboard" 
                                path="/coo/dashboard"
                            />
                        </Link>
                    </div>

                    <div className="menu-section">
                        <MenuItem 
                            icon={MdPeople}
                            text="Employees" 
                            onClick={() => handleDropdown('Employees')}
                            hasDropdown
                        />
                        <div className={`dropdown ${openDropdown === 'Employees' ? 'show' : ''}`}>
                            
                            <DropdownItem 
                                icon={MdViewList}
                                text="View Employees" 
                                path="/coo/employees"
                            />
                            <DropdownItem 
                                icon={MdAdd}
                                text="Add Employee" 
                                path="/coo/add-employee"
                            />
                             <DropdownItem 
                                icon={MdViewList}
                                text="Improvement Plans" 
                                path="/coo/hods-improvement-plans"
                            />
                        </div>
                        
                    </div>
                    

                    <div className="menu-section">
                        <MenuItem 
                            icon={MdBusinessCenter}
                            text="Key  Result Areas" 
                            onClick={() => handleDropdown('KRA')}
                            hasDropdown
                        />
                        <div className={`dropdown ${openDropdown === 'KRA' ? 'show' : ''}`}>
                            
                            <DropdownItem 
                                icon={MdAdd}
                                text="Add KRA" 
                                path="/coo/create-key-result-area"
                            />
                        </div>
                        <div className={`dropdown ${openDropdown === 'KRA' ? 'show' : ''}`}>
                            
                            <DropdownItem 
                                icon={MdViewList}
                                text="View KRAs" 
                                path="/coo/key-result-areas"
                            />
                        </div>
                    </div>

                    <div className="menu-section">
                        <MenuItem 
                            icon={MdTrackChanges}
                            text="My KPIs" 
                            onClick={() => handleDropdown('MyGoals')}
                            hasDropdown
                        />
                        <div className={`dropdown ${openDropdown === 'MyGoals' ? 'show' : ''}`}>
                            
                            <DropdownItem 
                                icon={MdAdd}
                                text="Create KPI" 
                                path="/coo/create-goal"
                            />
                        </div>
                        <div className={`dropdown ${openDropdown === 'MyGoals' ? 'show' : ''}`}>
                            
                            <DropdownItem 
                                icon={MdViewList}
                                text="View KPIs" 
                                path="/coo/goals"
                            />
                        </div>
                    </div>

                    <div className="menu-section">
                        <Link to="/coo/my-goals-reviews">
                            <MenuItem 
                                icon={MdViewList}
                                text="My KPIs Reviews" 
                                path="/coo/my-goals-reviews"
                            />
                        </Link>
                    </div>

                    <div className="menu-section">
                        <MenuItem 
                            icon={MdTrackChanges}
                            text="Improvement Plans" 
                            onClick={() => handleDropdown('MyIps')}
                            hasDropdown
                        />
                        <div className={`dropdown ${openDropdown === 'MyIps' ? 'show' : ''}`}>
                            
                            <DropdownItem 
                                icon={MdAdd}
                                text="Create IP" 
                                path="/coo/create-improvement-plan"
                            />
                        </div>
                        <div className={`dropdown ${openDropdown === 'MyIps' ? 'show' : ''}`}>
                            
                            <DropdownItem 
                                icon={MdViewList}
                                text="View IPs" 
                                path="/coo/improvement-plans"
                            />
                        </div>
                    </div>

                    <div className="menu-divider"></div>

                    <div className="menu-section secondary-menu">

                        <Link to="/coo/change-password">
                            <MenuItem 
                                icon={MdSettings}
                                text="Change Password" 
                                path="/coo/change-password"
                            />
                        </Link>
                    </div>

                    <div className="menu-item logout" onClick={handleLogout}>
                        <div className="menu-item-content">
                            <MdLogout className="menu-icon" />
                            <span className="menu-text">Logout</span>
                        </div>
                    </div>
                </div>
            </div>
            
            {isMobile && isOpen && (
                <div className="sidebar-overlay" onClick={toggleSidebar}></div>
            )}
        </>
    );
};

export default Sidebar;
